import { keyBy, isEmpty, mergeWith, values } from 'lodash';
import { ProgressStatus, ProjectPhase } from 'api/project';
import { StatusGroup } from 'api/tasks';

export const getProgress = (
  progressStatuses: ProgressStatus[],
): {
  completed: number;
  inProgress: number;
  total: number;
  completedPercent: number;
  inProgressPercent: number;
} => {
  const inProgress =
    progressStatuses.find((status) => status.group === StatusGroup.InProgress)
      ?.count || 0;
  const completed =
    progressStatuses.find((status) => status.group === StatusGroup.Completed)
      ?.count || 0;
  const total = progressStatuses.reduce(
    (prev, status) => prev + (status?.count || 0),
    0,
  );
  const completedPercent =
    total === 0 ? 0 : Number(((completed / total) * 100).toFixed(2));
  const inProgressPercent =
    total === 0 ? 0 : Number(((inProgress / total) * 100).toFixed(2));

  return {
    completed,
    total,
    inProgress,
    completedPercent,
    inProgressPercent,
  };
};

const statusMerger = (objVal: ProgressStatus, srcVal: ProgressStatus) => {
  return { ...srcVal, count: (srcVal?.count || 0) + (objVal?.count || 0) };
};

export const getAggregatedPhaseProgress = (
  projectPhases: ProjectPhase[],
): ProgressStatus[] => {
  const groupByProgress: {
    [value: number]: ProgressStatus;
  } = projectPhases?.reduce((acc, phase) => {
    const statusesObject = keyBy(phase.progressStatus, 'value');

    if (!isEmpty(statusesObject)) {
      return mergeWith(acc, statusesObject, statusMerger);
    }

    return acc;
  }, {});

  return values(groupByProgress);
};
